import React from 'react';
import { Link } from 'react-router-dom';

const FalsePage = () => {
    return (
        <div className='text-center py-20'>
            <h4 className='text-xl text-red-400 font-semibold'>Something went Wrong!</h4>
            <p className='mb-4'>Please Try Again!</p>
            <Link className='bg-blue-500 text-white px-5 py-2' to='/cart'>Go To Cart</Link>
        </div>
    );
};

export default FalsePage;